export default __webpack_public_path__ + "f2c6f0030c5e93b48a29e5f5ee33e3e1.svg";